<template>
  <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Send Rewards via Mail</h5>
          <span aria-hidden="true" role="button" @click="close"
            ><i class="fas fa-xmark"></i
          ></span>
        </div>
        <ul class="tab-panels">
          <li
            v-for="tab of tabPanels"
            :class="activeTab == tab.tabIndex ? 'active' : ''"
            :key="tab"
            @click="activeTab = tab.tabIndex"
          >
            {{ tab.tabName }}
          </li>
        </ul>
        <div class="modal-body">
          <div v-if="activeTab == 0">
            <Notifications @close="close" @send-reward="sendRewards" :data="this.data" :api="this.api"></Notifications>
          </div>
          <div v-else-if="activeTab == 1">
            <MailDescription @close="close" :data="this.data" :api="this.api"></MailDescription>
          </div>
        </div>
          
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "../Panels/Notifications.vue";
import MailDescription from "../Panels/MailDescription.vue";
import ToastService from "toast/src/services/toast";
import ModalService from "modal/src/services/Modal";

export default {
  name: "SendRewards",
  data() {
    return {
      tabPanels: [
        {
          name: "Send Notification",
          tabName: "Send Mail from Notification",
          tabIndex: 0,
        },
        {
          name: "Send Mail Description",
          tabName: "Send Mail from Mail Description",
          tabIndex: 1,
        },
      ],
      activeTab: 0,
    };
  },
  props: {
    data: {
      entity: Object,
      show: Boolean,
    },
    api: Object,
  },
  components: {
    Notifications,
    MailDescription
  },
  methods: {
    close() {
      let data = this.data;
      data.show = false;
    },

  sendRewards(...args){
    /*
      Guide
      0 = type
      1 = requiredId
      2 = validation
    */
    const types = { 0: "Notification", 1: "Mail Description" };
    let typeOfTransaction = types[args[0]] || "";
    
  if (!args[2]) {
    ToastService.Notify({
      title: "Failed",
      message: `Please select a ${typeOfTransaction}`,
    });
    return;
  }
  ModalService.Show(
    {
      title: `Send Reward  via Mail`,
      message: `Do you want to send ${args[2]}?`,
    },
    async () => {
      const res = await this.api.charlist.sendRewardsviaMail(this.data.entity._id, args[1], args[0]);
      if (res.message === "Failed") {
        ToastService.Notify({
          title: "Error",
          message: "Unable to save.",
        });
      } else {
        ToastService.Notify({
          title: "Success",
          message: `${args[2]} successfully sent!`,
        });
      }
      this.close();
    }
  );
}
    
  },
  mounted() {},
};
</script>

<style></style>
